import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { EDMUNDS_TESTED_COMPONENT } from 'site-modules/personalized-search/constants/tracking';

import './edmunds-tested.scss';

export function EdmundsTested({ className = '' }) {
  return (
    <span
      data-tracking-parent={EDMUNDS_TESTED_COMPONENT}
      className={classnames(
        'fw-medium text-blue-40 text-nowrap rounded-6 size-12 px-0_5 py-0_25 d-inline-block letter-spacing-1 bg-blue-90',
        className
      )}
    >
      edmunds
      <span className="ms-0_25 fw-bold letter-spacing-3 ">TESTED</span>
    </span>
  );
}

EdmundsTested.propTypes = { className: PropTypes.string };
